import { AxiosResponse } from 'axios';
import { bexHttpClient } from '../../clients';

/**
 * Surface (A2UI screen) CRUD. Backed by BeX Server (Redis); per app, stored
 * under `bexo:{org}:{app}:surfaces:{name}`. BeX Server is the sole writer;
 * BeXO reads. The surface `name` is the entity id.
 */
export interface Surface {
    org_id: string;
    app_id: string;
    name: string;
    title?: string;
    description?: string;
    catalogVersion: string;
    components: unknown[];
    dataModel?: Record<string, unknown>;
    active?: boolean;
}

class SurfaceService {
    async listSurfaces(orgId: string, appId: string): Promise<AxiosResponse> {
        return bexHttpClient.get('/redis/surfaces', {
            params: { org_id: orgId, app_id: appId },
        });
    }

    async getSurface(orgId: string, appId: string, name: string): Promise<AxiosResponse> {
        return bexHttpClient.get(`/redis/surfaces/${encodeURIComponent(name)}`, {
            params: { org_id: orgId, app_id: appId },
        });
    }

    async createSurface(data: Surface): Promise<AxiosResponse> {
        return bexHttpClient.post('/redis/surfaces', data);
    }

    async updateSurface(data: Surface): Promise<AxiosResponse> {
        return bexHttpClient.put('/redis/surfaces', data);
    }

    async deleteSurface(orgId: string, appId: string, name: string): Promise<AxiosResponse> {
        return bexHttpClient.delete(`/redis/surfaces/${encodeURIComponent(name)}`, {
            params: { org_id: orgId, app_id: appId },
        });
    }
}

const surfaceService = new SurfaceService();
export { surfaceService };
